import styled, { css } from 'styled-components';

export const WorkpackageItemCardStyled = styled.div`
  ${({ theme }) => css`
    /* FIXME: remove once ProgressBarDetail can adjust font size (or it scales to size prop) */
    font-size: ${theme.fontSizes[300]};
    color: ${theme.colors.grey[600]};
  `}
`;
